import { Badge } from '@amzn/awsui-components-console';
import { AncestryStatus } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

// Badge for a row's ancestry against the Public version set. Keyed on the string
// value so an unknown/new status falls through to grey without a compile-time
// dependency on a specific enum member. Color signals whether the user needs to
// act: green = no action (in sync or safely ahead of Public); red/yellow = action
// required (behind or diverged from Public); grey = missing information.
const ANCESTRY_COLORS: Record<
  string,
  'blue' | 'grey' | 'green' | 'red' | 'severity-low'
> = {
  NO_CHANGE: 'green',
  AHEAD: 'green',
  BEHIND: 'red',
  DIVERGED: 'severity-low',
  NOT_IN_PUBLIC: 'grey',
  UNKNOWN: 'grey',
};

export const AncestryBadge = ({
  status,
}: {
  status?: AncestryStatus | string;
}) => {
  if (!status) {
    return <>-</>;
  }
  const color = ANCESTRY_COLORS[status] ?? 'grey';
  return <Badge color={color}>{status}</Badge>;
};
